import { useEffect } from 'react';

const useSEO = ({
  title,
  description,
  canonical,
  noindex = false
}) => {
  useEffect(() => {
    const siteName = "JavaLearn – Java Certification Practice";
    const fullTitle = title ? `${title} | ${siteName}` : siteName;

    const safeDescription =
      description ||
      "Java certification practice platform with mock tests and detailed explanations.";

    document.title = fullTitle;

    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    updateMeta('description', safeDescription);
    updateMeta('robots', noindex ? 'noindex,nofollow' : 'index,follow');

    const cleanUrl =
      canonical || window.location.origin + window.location.pathname;

    updateMeta('og:title', fullTitle, true);
    updateMeta('og:description', safeDescription, true);
    updateMeta('og:url', cleanUrl, true);

    updateMeta('twitter:title', fullTitle);
    updateMeta('twitter:description', safeDescription);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', cleanUrl);

  }, [title, description, canonical, noindex]);
};

export default useSEO;
